import React from 'react'
import { BezierHandleDot } from '@/components/app/editor/tools/shared/components/bezier-handle-dot'
import { PEN_ACCENT_COLOR } from '../constants/pen-chrome'
import type { PenAnchorPoint } from '@/lib/elements/types/pen-anchor-point'

interface PenHandleLinesProps {
  points: PenAnchorPoint[]
  /** Handle line stroke width (canvas units). */
  sw: number
  /** Handle dot radius (canvas units). */
  handleR: number
  /** Handle dot outline width (canvas units). */
  handleStrokeWidth: number
}

/** Handle lines and endpoint circles for every anchor that has handles — display only. */
export function PenHandleLines({ points, sw, handleR, handleStrokeWidth }: PenHandleLinesProps) {
  return (
    <>
      {points.map((pt) => (
        <React.Fragment key={`${pt.id}-h`}>
          {pt.handleIn && (
            <BezierHandleDot
              anchorX={pt.x}
              anchorY={pt.y}
              handleX={pt.handleIn.x}
              handleY={pt.handleIn.y}
              radius={handleR}
              color={PEN_ACCENT_COLOR}
              lineWidth={sw}
              dotStrokeWidth={handleStrokeWidth}
              dotProps={{ pointerEvents: 'none' }}
            />
          )}
          {pt.handleOut && (
            <BezierHandleDot
              anchorX={pt.x}
              anchorY={pt.y}
              handleX={pt.handleOut.x}
              handleY={pt.handleOut.y}
              radius={handleR}
              color={PEN_ACCENT_COLOR}
              lineWidth={sw}
              dotStrokeWidth={handleStrokeWidth}
              dotProps={{ pointerEvents: 'none' }}
            />
          )}
        </React.Fragment>
      ))}
    </>
  )
}
